/**
 * Toggle WooCommerce Filters on mobile
 *
 * @since   1.0.0
 * @package premier
 */

(function($) {
    $(document).ready(function() {

        var filterToggle = $('.filter-toggle');

        if (filterToggle.length < 1) {
            return;
        }

        var filterToggleModule = (function() {

            var init = function() {

                var $aside = $('#secondary');
                filterSections = $('#secondary section:not(:first-of-type):not(:nth-of-type(2))');

                filterToggle.on('click', function() {
                    $aside.toggleClass('show-filters');
                    var $text = this.querySelector('span');
                    if ($aside.hasClass('show-filters')) {
                        TweenMax.staggerFromTo(filterSections, 0.25, {
                            autoAlpha: 0,
                        }, {
                            autoAlpha: 1,
                            ease: Expo.easeOut
                        }, 0.05);
                        $text.textContent = 'Hide Filters';
                    } else {
                        $text.textContent = 'Show Filters';
                    }
                });
            };

            return {
                init: init
            };
        })();

        filterToggleModule.init();

    }); // document.ready
})(jQuery);
